export enum ScrollDirection {
  FORWARD = 'FORWARD',
  REVERSE = 'REVERSE'
}
